import { useMemo } from 'react';
import { ProductCard, type ProductListing } from '@entities/product';
import { useGetBestSellersQuery } from '@entities/product/api/bestSellersApi';
import { HorizontalScroller } from '@shared/ui/HorizontalScroller/HorizontalScroller';

export function BestSellers({ listings, onSelect, onBuy, clockOffsetMs }: {
  listings: ProductListing[]; onSelect: (listing: ProductListing) => void; onBuy: (listing: ProductListing) => void; clockOffsetMs: number;
}) {
  const { data } = useGetBestSellersQuery(undefined, { refetchOnFocus: true });
  const ranked = useMemo(() => {
    const counts = new Map((data ?? []).map(item => [item.productId, item.salesCount]));
    return listings.map(listing => ({ listing, sales: listing.variants.reduce((total, variant) => total + (counts.get(variant.product.id) ?? 0), 0) }))
      .filter(item => item.sales > 0).sort((a,b) => b.sales - a.sales).slice(0, 10);
  }, [data, listings]);
  // An empty market has no best sellers yet; never substitute editorial picks or invented sales.
  if (!ranked.length) return null;
  return <HorizontalScroller title="Best sellers" description="Most bought digital products" itemWidth="clamp(172px, 16vw, 216px)">
    {ranked.map(({ listing }) => <ProductCard key={listing.key} listing={listing} onSelect={onSelect} onBuy={onBuy} eager clockOffsetMs={clockOffsetMs} />)}
  </HorizontalScroller>;
}
